import type { AnyRouteMatch } from '@tanstack/react-router';

// Legacy route redirects from react-router migration
// Maps old route patterns to new TanStack Router paths
const legacyRouteRedirects: Array<{
  pattern: RegExp;
  getNewPath: (match: RegExpMatchArray) => string;
}> = [
  // Static routes
  {
    pattern: /^\/deliveries\/?$/,
    getNewPath: () => '/deliveries/all',
  },
  {
    pattern: /^\/create-delivery-note\/?$/,
    getNewPath: () => '/deliveries/all/create-delivery-note',
  },
  {
    pattern: /^\/deliveries\/create-delivery-note\/?$/,
    getNewPath: () => '/deliveries/all/create-delivery-note',
  },
  {
    pattern: /^\/create-service-note\/?$/,
    getNewPath: () => '/deliveries/all/create-service-note',
  },
  {
    pattern: /^\/deliveries\/create-service-note\/?$/,
    getNewPath: () => '/deliveries/all/create-service-note',
  },
  { pattern: /^\/data-exchange$/, getNewPath: () => '/suppliers' },
  {
    pattern: /^\/data-sync-jobs$/,
    getNewPath: () => '/settings/admin/data-sync',
  },
  {
    pattern: /^\/incoming-invoices$/,
    getNewPath: () => '/invoices/incoming',
  },
  {
    pattern: /^\/outgoing-invoices$/,
    getNewPath: () => '/invoices/outgoing',
  },
  {
    pattern: /^\/settings\/admin\/article-master\/articles$/,
    getNewPath: () => '/settings/article-master/articles',
  },
  {
    pattern: /^\/settings\/admin\/article-master\/categories$/,
    getNewPath: () => '/settings/article-master/categories',
  },
  {
    pattern: /^\/settings\/masterdata\/company$/,
    getNewPath: () => '/settings/masterdata/companies',
  },
  {
    pattern: /^\/settings\/masterdata\/cost-center$/,
    getNewPath: () => '/settings/masterdata/cost-centers',
  },
  {
    pattern: /^\/settings\/masterdata\/organisational-group$/,
    getNewPath: () => '/settings/masterdata/org-groups',
  },
  {
    pattern: /^\/settings\/admin\/pdf$/,
    getNewPath: () => '/settings/admin/pdf-settings',
  },
  {
    pattern: /^\/settings\/masterdata\/site$/,
    getNewPath: () => '/settings/masterdata/sites',
  },
  {
    pattern: /^\/settings\/masterdata\/employees$/,
    getNewPath: () => '/settings/masterdata/users',
  },
  {
    pattern: /^\/settings\/masterdata\/user-group$/,
    getNewPath: () => '/settings/masterdata/user-groups',
  },
  {
    pattern: /^\/settings\/masterdata\/vehicle$/,
    getNewPath: () => '/settings/masterdata/vehicles',
  },
  {
    pattern: /^\/settings\/admin\/invoice-check-ignored-articles$/,
    getNewPath: () => '/settings/ignored-articles',
  },
  {
    pattern: /^\/settings\/masterdata\/product-price$/,
    getNewPath: () => '/settings/product-price',
  },
  { pattern: /^\/settings\/demo$/, getNewPath: () => '/settings/admin/demo' },
  // Dynamic routes with path params
  {
    pattern: /^\/deliveries\/([0-9a-f-]{36})\/?$/,
    getNewPath: (match) => `/deliveries/all/${match[1]}`,
  },
  {
    pattern: /^\/delivery-note\/(.+)$/,
    getNewPath: (match) => `/deliveries/${match[1]}`,
  },
  {
    pattern: /^\/delivery-note-data-quality\/(.+)$/,
    getNewPath: (match) => `/deliveries/${match[1]}/data-quality`,
  },
  {
    pattern: /^\/incoming-invoices\/invoice\/(.+)$/,
    getNewPath: (match) => `/invoices/incoming/${match[1]}`,
  },
  {
    pattern: /^\/invoice-link\/(.+)$/,
    getNewPath: (match) => `/invoices/incoming/${match[1]}`,
  },
];

export const getLegacyRedirectPath = (pathname: string): string | undefined => {
  for (const { pattern, getNewPath } of legacyRouteRedirects) {
    const match = pathname.match(pattern);
    if (match) {
      return getNewPath(match);
    }
  }

  return undefined;
};

export const getRouteHead = (
  title: string,
  description?: string,
): {
  links?: AnyRouteMatch['links'];
  scripts?: AnyRouteMatch['headScripts'];
  meta?: AnyRouteMatch['meta'];
  styles?: AnyRouteMatch['styles'];
} => {
  return {
    meta: [
      {
        title: `${title} | Vestigas`,
      },
      {
        content: description,
        name: 'description',
      },
    ],
  };
};
